import COUNTRIES from '../countries.translations'

import translations from './cobalt.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/cobalt'

export const cobalt: Metal = {
  id: 7,
  slug: 'cobalt',
  name: t.name,
  symbol: 'Co',
  mines: [
    {
      name: 'Tenke Fungurume (DRC, CMOC)',
      region: t.mine0Region,
      slug: 'tenke-fungurume',
      coordinates: [26.13, -10.58],
    },
    {
      name: 'Mutanda & Kamoto (DRC, Glencore)',
      region: t.mine1Region,
      slug: 'mutanda-kamoto',
      coordinates: [26.28, -10.72],
    },
    {
      name: 'Norilsk-Talnakh (Russia, Nornickel)',
      region: t.mine2Region,
      slug: 'norilsk-talnakh',
      coordinates: [88.38, 69.49],
    },
    {
      name: 'Murrin Murrin (Australia, Glencore)',
      region: t.mine3Region,
      slug: 'murrin-murrin',
      coordinates: [121.89, -28.72],
    },
  ],
  countries: [
    { name: COUNTRIES.democraticRepublicCongo, percent: 75.9 },
    { name: COUNTRIES.indonesia, percent: 9.7 },
    { name: COUNTRIES.russia, percent: 3 },
    { name: COUNTRIES.canada, percent: 1.6 },
    { name: COUNTRIES.australia, percent: 1.2 },
  ],
  important: true,
  // Dug alongside copper and nickel — cobalt is a by-product of both.
  related: ['copper', 'nickel'],
  video: {
    name: 'cobalt',
    poster: '/mine-my-phone/images/posters/cobalt.jpg',
  },
  // Scores and imagery are authored here; every word comes from the translations file.
  content: {
    smartphone: {
      quantityScore: 4,
      quantityLabel: t.smartphone.label,
      parts: ['battery'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 3, ...t.impacts.human },
      geopolitical: { severity: 5, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 2, ...t.supplyRisk },
    recycling: { score: 3, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
          credit: 'Bloomberg / Getty',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'horizontal',
        },
      ],
      secondBento: [
        {
          src: `${dir}/05.jpg`,
          orientation: 'horizontal',
          credit: 'Michel Lunanga / Getty',
        },
        {
          src: `${dir}/06.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/07.jpg`,
          orientation: 'vertical',
          credit: 'Pes-Anders Pettersson / Getty',
        },
      ],
    },
  },
}
